module.exports = __webpack_public_path__ + "img/sentra_side.1b3447af.png";